module.exports = __webpack_public_path__ + "media/Video-for-animation-1.018fc9a7.mp4";